import React, { useState, useEffect } from "react";
import { Modal, ModalBody, ModalFooter, Row, Col } from "reactstrap";
import * as url from "../../../../helpers/url_helper";
import { toast } from "react-toastify";
import { Card, CardBody } from "reactstrap";
import { useSelector } from "react-redux";
import axios from "axios";

export interface modelType {
  headerTitle: string;
  idName: string;
  assignData?: any;
  cancleBtnClick(): void;
  handleRefresh(): void;
}

const AssignRoomModal = ({
  headerTitle,
  assignData,
  cancleBtnClick,
  handleRefresh,
  idName = "",
}: modelType) => {
  console.log("assignData: ", assignData);
  const token = localStorage.getItem("Authorization");

  const roomList = useSelector((state: any) => state.APIResponse.roomList);
  const profileDetails = useSelector(
    (state: any) => state.APIResponse.profileDetails
  );
  const [selectedRoomId, setSelectedRoomId] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (assignData?.roomName && roomList.length > 0) {
      const matchedRoom = roomList.find(
        (room: any) => room.name === assignData.roomName
      );
      if (matchedRoom) {
        setSelectedRoomId(matchedRoom.id);
      }
    }
  }, [assignData, roomList]);
  const handleRoomCheckboxChange = (roomId: string) => {
    setSelectedRoomId((prevSelected) =>
      prevSelected === roomId ? null : roomId
    );
  };

  const assignDevicesToRoom = async () => {
    if (idName === "Chiplist") {
      if (!assignData?.switches || assignData.switches <= 0) {
        toast.info("Switch not available for this device.");
        return;
      }
    }
    if (!profileDetails?.id || !selectedRoomId || !assignData?.id) return;
    setLoading(true);
    const apiURL = `${url.BASE_URL}${url.ASSIGN_ROOM}`;
    const payload = {
      targetUserId: profileDetails.id,
      roomId: selectedRoomId,
      blasterIds: idName === "Blasterlist" ? [assignData?.id] : [],
      chipIds: idName === "Chiplist" ? [assignData?.id] : [],
      airCurtainId: idName === "Curtainlist" ? [assignData?.id] : [],
      lockIds: idName === "Locklist" ? [assignData?.id] : [],
      iotDevices: idName === "Driverlist" ? [assignData?.id] : [],
    };

    try {
      const response = await axios.post(apiURL, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success(response.data?.msg);
      setSelectedRoomId(null);
      handleRefresh();
      cancleBtnClick();
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Modal
        isOpen={true}
        className="modal-lg"
        style={{
          backgroundColor: "#F7F7FA",
          borderRadius: "12px",
          padding: "0px",
        }}
      >
        <div className="modal-header justify-content-between">
          <div className="d-flex flex-column align-items-center">
            <h5
              className="modal-title"
              id="staticBackdropLabel"
              style={{ textAlign: "center" }}
            >
              {headerTitle}
            </h5>
          </div>
          <div className="d-flex flex-column align-items-center">
            {assignData?.slave && (
              <h6
                className="modal-title "
                style={{ textAlign: "center", fontSize: "20px" }}
              >
                Slave: {assignData?.slave}
              </h6>
            )}
          </div>
          <button
            className="btn p-0 d-flex align-items-center"
            style={{
              border: "none",
            }}
            onClick={cancleBtnClick}
            title="Close"
          >
            <box-icon name="x" size="30px"></box-icon>
          </button>
        </div>

        <ModalBody style={{ padding: 0 }}>
          <div
            style={{
              maxHeight: "70vh",
              overflowY: "auto",
              overflowX: "auto",
              backgroundColor: "#F7F7FA",
              padding: "20px",
            }}
          >
            <Card className="mb-0">
              <CardBody>
                <h5 className="mb-2">Select Room</h5>
                {roomList && roomList.length > 0 ? (
                  <div
                    style={{
                      borderRadius: "8px",
                      backgroundColor: "#ffffff",
                      padding: "10px",
                    }}
                  >
                    <Row className="g-2">
                      {roomList.map((room: any) => (
                        <Col
                          key={room.id}
                          lg={3}
                          md={3}
                          sm={4}
                          xs={6}
                          className="d-flex align-items-center"
                          style={{ fontSize: 14 }}
                        >
                          <input
                            className="me-2"
                            type="checkbox"
                            id={`room-${room.id}`}
                            value={room.id}
                            checked={selectedRoomId === room.id}
                            onChange={() => handleRoomCheckboxChange(room.id)}
                            style={{ accentColor: "#343A40" }}
                          />
                          <label
                            className="form-check-label mb-0"
                            htmlFor={`room-${room.id}`}
                            style={{ cursor: "pointer" }}
                          >
                            {room.name}
                          </label>
                        </Col>
                      ))}
                    </Row>
                  </div>
                ) : (
                  <p className="text-muted">No rooms available.</p>
                )}
              </CardBody>
            </Card>
          </div>
        </ModalBody>

        <ModalFooter
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <button
            className="btn btn-outline-secondary"
            onClick={cancleBtnClick}
            style={{ marginLeft: "auto" }}
          >
            Cancel
          </button>
          <button
            className="btn btn-dark"
            onClick={() => assignDevicesToRoom()}
            disabled={loading && true}
          >
            <span>{loading ? "Assigning..." : "Assign Room"}</span>
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default AssignRoomModal;
export const customStyles: any = {
  headRow: {
    style: {
      backgroundColor: "#EFF2F7",
      fontWeight: "bold",
      fontSize: "14px",
      borderBottom: "0px solid #ced4da",
    },
  },
};
